import React from 'react';
import { getStreakLevel, getNextMilestone } from '../services/streakService';

function StreakDisplay({ streakStats, showDetails = true }) {
  if (!streakStats) {
    return null;
  }

  const { currentStreak, longestStreak, currentLevel, nextMilestone, streakIntensity } = streakStats;
  
  const getFlameIntensity = () => {
    if (currentStreak === 0) return 'no-flame';
    if (currentStreak < 3) return 'spark';
    if (currentStreak < 7) return 'ember';
    if (currentStreak < 14) return 'flame';
    if (currentStreak < 30) return 'inferno';
    return 'eternal';
  };

  const flameIntensity = getFlameIntensity();

  return (
    <div className="streak-display">
      {showDetails && (
        <div className="streak-header">
          <h3 className="streak-title">🔥 Debate Streak</h3>
        </div>
      )}
      
      <div className="streak-stats">
        <div className="streak-current">
          <div className={`streak-flame ${flameIntensity}`}>
            🔥
          </div>
          <div className="streak-info">
            <div className="streak-number">{currentStreak}</div>
            <div className="streak-label">
              {currentStreak === 1 ? 'Day' : 'Days'}
            </div>
            {currentLevel && (
              <div className="streak-level">{currentLevel.name}</div>
            )}
          </div>
        </div>
        
        {showDetails && (
          <div className="streak-details">
            <div className="streak-stat">
              <span className="stat-label">Longest Streak:</span>
              <span className="stat-value">{longestStreak} days</span>
            </div>
            
            {nextMilestone && (
              <div className="streak-progress">
                <div className="progress-label">
                  Next: {nextMilestone.level.name} in {nextMilestone.daysLeft} {nextMilestone.daysLeft === 1 ? 'day' : 'days'}
                </div>
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{
                      width: `${(currentStreak / nextMilestone.days) * 100}%`
                    }}
                  ></div>
                </div>
              </div>
            )}
            
            {currentStreak >= 30 && (
              <div className="streak-legend">
                🏆 You've reached legendary status!
              </div>
            )}
          </div>
        )}
      </div>
      
      {currentStreak > 0 && (
        <div className="streak-motivation">
          {currentStreak === 1 && "🌟 Great start! Keep the momentum going!"}
          {currentStreak >= 2 && currentStreak < 7 && "🔥 You're building heat! Don't break the chain!"}
          {currentStreak >= 7 && currentStreak < 14 && "🌟 You're on fire! This is becoming a habit!"}
          {currentStreak >= 14 && currentStreak < 30 && "🚀 Incredible dedication! You're a debate machine!"}
          {currentStreak >= 30 && "👑 Legendary! You're the debate champion!"}
        </div>
      )}
    </div>
  );
}

export default StreakDisplay;